import { Button, Group, SimpleGrid, Stack, Text } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { Review } from "../../Model/Review.model";
import { formatReviewCount, getReviewHeadline, getReviewSummary } from "../../Services/review.service";
import { HugeTitle } from "../Shared/HugeTitle";
import SectionHeader from "../Shared/SectionHeader";
import ReviewCard from "./ReviewCard";
import ReviewsTrustBar from "./ReviewsTrustBar";
import "./Reviews.css";

interface ReviewsPreviewSectionProps {
  title?: string;
  description?: string;
  reviews: Review[];
  id?: string;
  compactCards?: boolean;
  plainTrustBar?: boolean;
}

function ReviewsPreviewSection({
  title = "Reviews and trust go hand in hand",
  description = "Read what students say about the clarity, pace, and confidence they gained from SubjectBuddy support across assignments, dissertations, coding tasks, and urgent deadlines.",
  reviews,
  id,
  compactCards = false,
  plainTrustBar = false,
}: ReviewsPreviewSectionProps) {
  const summary = getReviewSummary();

  return (
    <Stack gap="xl" id={id}>
      <Stack gap="md" align="center">
        <SectionHeader>
          <HugeTitle
            style={{
              fontSize: "2.5rem",
              textAlign: "center",
            }}
          >
            {title}
          </HugeTitle>
        </SectionHeader>
        <Text ta="center" c="dimmed" maw={860} style={{ lineHeight: 1.8 }}>
          {description}
        </Text>
        <Text size="sm" fw={700} c="green">
          {getReviewHeadline()}
        </Text>
      </Stack>

      <ReviewsTrustBar unstyled={plainTrustBar} />

      <SimpleGrid
        cols={{ base: 1, md: 2, lg: reviews.length > 2 ? 3 : 2 }}
        spacing="lg"
      >
        {reviews.map((review) => (
          <ReviewCard key={review.id} review={review} compact={compactCards} />
        ))}
      </SimpleGrid>

      <Group justify="space-between" align="center" wrap="wrap">
        <Text c="dimmed">
          Showing selected feedback from {formatReviewCount(summary.totalReviews)} total reviews.
        </Text>
        <Button
          component={Link}
          to="/reviews"
          color="green"
          radius="xl"
          rightSection={<IconArrowRight size={16} />}
        >
          Browse all reviews
        </Button>
      </Group>
    </Stack>
  );
}

export default ReviewsPreviewSection;
